import grapesjs from 'drapcode-builder';
import loadComponents from './components';

export default grapesjs.plugins.add('autocomplete-input', (editor, opts = {}) => {
  let configOpts = opts || {};

  let default_types = {
    autocompleteInput: 'autocomplete-input',
    autocompleteInputContainer: 'autocomplete-input-container',
  };

  let default_labels = {
    autocompleteInput: 'Auto Complete Input',
    autocompleteInputContainer: 'Auto Complete Input Container',
  };

  let options = {
    ...{
      labels: default_labels,
      types: default_types,
      labelAutocompleteInputCategory: 'Forms',
    },
    ...configOpts,
  };
  loadComponents(editor, options);
});
